import React from 'react';
import useStyles from './Avatar.styles';

export const Avatar: React.FC = () => {
  const classes = useStyles();
  return <div className={classes.avatarImage} />;
};
